export enum Brand {
  Very = "very",
  VeryIE = "veryireland",
  Littlewoods = "littlewoods",
}
